// Set height of dropdown menu
const header = document.querySelector('header-component');
const menuListItem = document.querySelector('.menu-list__list-item');

/** @type {HTMLElement | null} */
const menuListDropdown = menuListItem && menuListItem.querySelector('.menu-list__submenu--dropdown');

menuListItem?.addEventListener('mouseover', () => {
  if (!header || !menuListDropdown) return;

  const value = getComputedStyle(header)
    .getPropertyValue('--full-open-header-height')
    .trim();

  menuListDropdown.style.height = value;
});

menuListItem?.addEventListener('mouseleave', () => {
  if (!menuListDropdown) return;
  menuListDropdown.style.height = '';
})

// Set current tab in collection tabs
document.querySelectorAll('.tabs__buttons .tab-button').forEach((button) => {
  button.addEventListener('click', () => {
    const id = button.getAttribute('data-tab-id');
    if (!id) return;

    // buttons
    document.querySelectorAll('.tabs__buttons .tab-button').forEach((btn) => {
      btn.setAttribute('aria-current', String(btn.getAttribute('data-tab-id') === id));
    });

    // panels
    document.querySelectorAll('.tabs__content .tab-panel').forEach((panel) => {
      panel.setAttribute('aria-current', String(panel.getAttribute('data-tab-id') === id));
    });
  });
});

// Replace sold out badge for archived products
document.querySelectorAll('.product-card:has(.is-archived) .product-badges__badge--rectangle').forEach((badge) => {
  if (badge.textContent.trim() === 'Sold out') {
    badge.textContent = 'Discontinued';
  }
});

// Create view button on archived products
document.querySelectorAll('.product-card:has(.is-archived)').forEach((productCard) => {
  const cardGallery = productCard.querySelector('.card-gallery');
  const link = productCard.querySelector('a.contents')

  const button = document.createElement('a');
  button.className = 'view-archive-button';
  button.href = link?.getAttribute('href') ?? '';
  button.textContent = 'View archive';

  cardGallery?.appendChild(button);
});

// Replace add to cart button text
document.querySelectorAll('.quick-add__button').forEach((button) => {
  const text = button.querySelector(
    '.add-to-cart-text__content span span'
  );

  if (text?.textContent.trim() === 'Add') {
    text.textContent = 'Add to cart';
  }
});

// Open new tab when clicking image block link
document.querySelectorAll('a.image-block').forEach((link) => {
  link.setAttribute('target', '_blank');
});
